const requestStatus = {
  initial: 'initial',
  fetching: 'fetching',
  success: 'success',
  failure: 'failure',
} as const;

export type RequestStatus = (typeof requestStatus)[keyof typeof requestStatus];

export default requestStatus;
